<div *ngIf="item" class="tree">
  <ul>
    <li>
      <div class="card">
        <nz-descriptions [nzTitle]="nomeRazaoSocial(item)">
          <nz-descriptions-item nzTitle="Nome Fantasia" [nzSpan]="3">{{ item?.nomeFantasia }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="CNPJ" [nzSpan]="3">{{ item?.cnpj | cnpj }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Tipo Relação" [nzSpan]="3" *ngIf="item?.tipoRelacao">{{ item?.tipoRelacao }}</nz-descriptions-item>
        </nz-descriptions>
      </div>

      <button nz-button nzType="default" nzShape="circle" nzValue="small" type="button" class="btn-arvore"
        *ngIf="item.childrenInferior && item.childrenInferior.length" (click)="item.expanded = !item.expanded; expandedChange.emit(true)">
        <span nz-icon [nzType]="item.expanded ? 'up' : 'down'" nzTheme="outline"></span>
      </button>

      <ul *ngIf="item.expanded">
        <li *ngFor="let child of item.childrenInferior">
          <app-arvore-hierarquica [item]="child" [level]="level + 1" (expandedChange)="onChildExpand($event)"></app-arvore-hierarquica>
        </li>
      </ul>
    </li>
  </ul>
</div>
